/**
 * Validators for ReduxForm Fields
 * call with error message or translate function for default value
 */
import i18n from "i18next";
import moment from "moment";

export const required = errorMessage => value =>
  value && value !== ""
    ? undefined
    : resolveMessage(errorMessage, i18n.t("validator.required"));

export const email = errorMessage => value => {
  return value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? resolveMessage(errorMessage, i18n.t("validator.email"))
    : undefined;
};

export const inss = errorMessage => value => {
  if (value) {
    value = value.replace(/\D/g, "");
    if (value.length === 11) {
      const formattedInss = value.split(/(\d{6})(\d{3})(\d{2})/);
      const inssNoCheckNumber = formattedInss[1] + formattedInss[2];
      const checkNumber = formattedInss[3];
      return parseInt(checkNumber, 10) ===
        97 - (parseInt(inssNoCheckNumber, 10) % 97)
        ? undefined
        : i18n.t("validator.inss");
    }
  }
  return undefined;
};

export const minLength = (length, errorMessage) => value => {
  if (value) {
    return value.length >= length
      ? undefined
      : resolveMessage(errorMessage, i18n.t("validator.minLength") + length);
  }
};
export const maxLength = (length, errorMessage) => value => {
  if (value) {
    return value.length <= length
      ? undefined
      : resolveMessage(errorMessage, i18n.t("validator.maxLength") + length);
  }
};

export const nihii = errorMessage => value => {
  if (value) {
    value = value.replace(/\D/g, "");
    value = value.substring(0, 8);
    return checkModulo87(value) || checkModulo97(value)
      ? undefined
      : resolveMessage(errorMessage, i18n.t("validator.nihii"));
  }
  return undefined;
};

const checkModulo87 = value => {
  const number = Number(value.substring(0, 6));
  const checkValue = Number(value.substring(6, 8));
  const remainder = number % 87;
  return checkValue === 87 - remainder;
};

const checkModulo97 = value => {
  const number = Number(value.substring(0, 6));
  const checkValue = Number(value.substring(6, 8));
  const remainder = number % 97;
  return checkValue === 97 - remainder;
};

export const cardNumber = errorMessage => value => {
  if (value) {
    if (value.length === 12) {
      const number = Number(value.substring(0, 10));
      const checkValue = Number(value.substring(10, 12));
      const remainder = number % 97;
      return checkValue === remainder
        ? undefined
        : resolveMessage(errorMessage, i18n.t("validator.cardNumber"));
    } else if (value.length === 10 && value.substring(0, 1) === "B") {
      const number = Number(value.substring(1, 8));
      const checkValue = Number(value.substring(8, 10));
      const remainder = number % 97;
      return checkValue === remainder
        ? undefined
        : resolveMessage(errorMessage, i18n.t("validator.cardNumber"));
    } else {
      resolveMessage(errorMessage, i18n.t("validator.cardNumber"));
    }
    return value.match(/^[a-zA-Z0-9]*$/)
      ? undefined
      : resolveMessage(errorMessage, i18n.t("validator.cardNumber"));
  }
  return undefined;
};

const parseDate = value => {
  const formats = ["YYYY-MM-DD", "DD/MM/YYYY", "D/M/YYYY"];
  return moment(value, formats, true);
};

export const time = errorMessage => value => {
  const formats = ["H:mm", "HH:mm"];
  return moment(value, formats, true).isValid() || !value
    ? undefined
    : resolveMessage(errorMessage, i18n.t("validator.time"));
};

export const date = errorMessage => value => {
  return parseDate(value).isValid() || !value
    ? undefined
    : resolveMessage(errorMessage, i18n.t("validator.date"));
};

export const pastDate = errorMessage => value => {
  if (value) {
    const date = parseDate(value);
    return !date.isValid() || date.isSameOrBefore(moment(), "date")
      ? undefined
      : resolveMessage(errorMessage, i18n.t("validator.dateIsInFuture"));
  }
};

export const pastDateTime = errorMessage => value => {
  if (value) {
    const date = moment(value);
    return !date.isValid() || date.isSameOrBefore(moment(), "date")
      ? undefined
      : resolveMessage(errorMessage, i18n.t("validator.dateIsInFuture"));
  }
};

const resolveMessage = (errorMessage, defaultMessage) => {
  return errorMessage ? errorMessage : defaultMessage;
};

export const dateIsInFuture = errorMessage => value => {
  if (
    value &&
    moment(value).format("YYYY-MM-DD") <=
      moment()
        .subtract(1, "days")
        .format("YYYY-MM-DD")
  ) {
    return resolveMessage(errorMessage, i18n.t("validator.dateIsInPast"));
  } else {
    return undefined;
  }
};
